import theme_icons from '../../icons.js';
import { AdderGeneric } from '../../components/adder-generic.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls } = wp.blockEditor;
const { Button, PanelBody, SelectControl } = wp.components;
const { RawHTML, useEffect } = wp.element;

const ghpolaroids = {
  title: 'Greenheart Polaroids',
  icon: theme_icons.greenheart,
  category: 'greenheart',
  //attributes
  attributes: {
    title: {
      type: 'string',
      default: ''
    },
    text: {
      type: 'string',
      default: ''
    },
    cards: {
      type: 'array',
      default: []
    },
    cardTitle: {
      type: 'string',
      default: ''
    },
    cardText: {
      type: 'string',
      default: ''
    },
    cardMeta: {
      type: 'string',
      default: ''
    },
    cardImage: {
      type: 'object',
      default: {}
    },
    cardId: {
      type: 'number',
      default: 1
    },
    isEditing: {
      type: 'number',
      default: null
    },
    cardIndex: {
      type: 'number',
      default: 0
    },
    cardSize: {
      type: 'string',
      default: ''
    }
  },

  edit({ attributes, setAttributes }) {
    const { title, text, cards, cardTitle, cardText, cardImage, cardId, isEditing, cardIndex, cardSize } = attributes;
    useEffect(() => {
      // Initialize cardId to 1 if it's zero (i.e., first time loading)
      if (cardId === 0) {
        setAttributes({ cardId: getNextCardId() });
      }
    }, [cardId]);

    const getNextCardId = () => {
      // Generate an array of all possible IDs from 1 to cards.length + 1
      const possibleIds = Array.from({ length: cards.length + 1 }, (_, i) => i + 1);

      // Get an array of used IDs
      const usedIds = cards.map(card => card.id);
      const availableIds = possibleIds.filter(id => !usedIds.includes(id));
      return Math.min(...availableIds);
    };
    const newPhoto = () => {
      setAttributes({
        cardTitle: '',
        cardText: '',
        cardImage: {},
        cardId: getNextCardId(),  // Always generate a new ID
        isEditing: true,
        cardIndex: cards.length  // Set the index to the current length of the cards array
      });
    };
    const editPhoto = (id) => {
      let card = cards.filter(card => card.id === id)[0];
      let filteredCards = cards.filter(card => card.id !== id);
      setAttributes({
        cardTitle: card.title,
        cardText: card.text,
        cardImage: card.image,
        cardId: id,
        isEditing: true,
        cardIndex: card.index,
        cards: filteredCards
      });
    }
    const deletePhoto = (id) => {
      let filteredCards = cards.filter(card => card.id !== id);
      setAttributes({ cards: filteredCards, isEditing: false, cardId: id });
    }
    const savePhoto = () => {
      const newCard = {
        id: cardId,
        title: cardTitle,
        text: cardText,
        image: cardImage,
        index: cardIndex,
      };
      console.log("New Card", newCard);
      const newCards = [...cards.filter(card => card.id !== cardId), newCard];
      console.log("new Cards", newCards);
      setAttributes({ cards: newCards });
      resetCards();
    }

    const resetCards = () => {
      setAttributes({
        cardText: '',
        cardTitle: '',
        cardImage: {},
        cardId: 0,
        isEditing: false,
      });
    }
    const getPhotoUrl = (image) => {
      console.log("Image", image);
      if (image.mediaSizes.hasOwnProperty('rbt-square-md')) {
        return image.mediaSizes['rbt-square-md'].url;
      } else {
        return image.mediaUrl;
      }
    }
    const displayPhotos = () => {
      return (
        cards.map(card => {
          return (
            <div className="polaroid">
              <img src={getPhotoUrl(card.image)} loading="lazy" alt={card.title} />
              <div className="caption">
                {card.title.length ? <h2><RawHTML>{card.title}</RawHTML></h2> : null}
                {card.text.length ? <p><RawHTML>{card.text}</RawHTML></p> : null}
                <div className="edit-delete">
                  <button className="button button-secondary secondary" onClick={() => editPhoto(card.id)}>Edit</button>
                  <button className="button button-primary primary" onClick={() => deletePhoto(card.id)}>Delete</button>
                </div>
              </div>
            </div>
          )
        })
      )
    };

    return ([
      <InspectorControls>
        <PanelBody title={__('Polaroid Settings')}>
          <p><em>Note: This block works best with under 5 polaroids.</em></p>
          <p><strong>Image Size:</strong></p>
          <SelectControl
            label="Image Size"
            value={cardSize}
            options={[
              { label: 'Small', value: 'small' },
              { label: 'Full', value: 'medium' },
            ]}
            onChange={(newSize) => setAttributes({ cardSize: newSize })}
          />
        </PanelBody>
      </InspectorControls>,
      <div className="rbt-ghpolaroids">
        <div className="rbt-ghpolaroids-cards">
          {isEditing &&
            <div className="rbt-ghpolaroids-edit">
              <div className="polaroid">
                <div className="image-area">
                  <MediaUploaderGeneric photo={cardImage} updateImage={(newImage => setAttributes({ cardImage: newImage }))} />
                </div>
                <div className="text-area">
                  <RichText
                    tagName="h2"
                    className="img-title"
                    value={cardTitle}
                    onChange={(newtitle) => setAttributes({ cardTitle: newtitle })}
                    placeholder={'Polaroid Title'}
                  />
                  <RichText
                    tagName="div"
                    className="img-text"
                    value={cardText}
                    onChange={(newtext) => setAttributes({ cardText: newtext })}
                    placeholder={'Aug 12, 2024'}
                  />
                </div>
              </div>

              <div className="save-edit-buttons">
                {cardImage &&
                  <Button className="primary button" onClick={savePhoto}>Save</Button>
                }
                <Button className="secondary button" onClick={resetCards}>Cancel</Button>
              </div>

            </div>
          }
          {!isEditing &&
            <div className="rbt-polaroids-display">
              {displayPhotos()}
              <AdderGeneric onAdd={newPhoto} />
            </div>
          }
        </div>
        <div className="rbt-ghpolaroids-text">
          <RichText
            tagName="h2"
            className="rbt-title"
            value={title}
            onChange={(newtitle) => setAttributes({ title: newtitle })}
            placeholder={'Block Title'}
          />
          <RichText
            tagName="div"
            className="rbt-text"
            value={text}
            onChange={(newtext) => setAttributes({ text: newtext })}
            placeholder={'Block Text'}
          />
        </div>
      </div>
    ]);
  },
  save({ attributes }) {
    const { title, text, cards, cardSize } = attributes;
    // const scriptInner = `
    //   if (typeof setUpPolaroids !== "function") {
    //     const setUpPolaroids = () => {
    //       const decks = document.querySelectorAll('.deck');
    //       decks.forEach(deck => {
    //         // Define cards and deckHeight here
    //         const cards = Array.from(deck.querySelectorAll('.polaroid'));
    //         let deckHeight = 0;

    //         const updateDeckHeight = () => {
    //           deckHeight = deck.clientHeight;

    //           // Apply initial offset and z-index
    //           let totalOffset = 0;
    //           cards.forEach((card, index) => {
    //             const offset = index * 8;
    //             card.style.transform = \`rotate(-3deg) translate(\${offset}px, \${offset}px)\`;
    //             card.style.zIndex = index; // Set z-index based on order
    //             totalOffset = offset;
    //           });

    //           deck.style.height = \`\${totalOffset + deckHeight}px\`; // Set the height of the deck based on the total offset
    //         };

    //         const shuffleCards = () => {
    //           // Remove shuffling class from all cards
    //           cards.forEach(card => card.classList.remove('shuffling'));

    //           // Move the first card to the end
    //           const firstCard = cards.shift(); // Remove the first card
    //           cards.push(firstCard); // Move it to the end of the array

    //           // Update positions and z-indexes with shuffling animation
    //           cards.forEach((card, index) => {
    //             const offset = index * 8;
    //             card.style.zIndex = index;
    //             card.style.transform = \`rotate(-3deg) translate(\${offset}px, \${offset}px)\`;
    //           });

    //           // Apply shuffling animation to the first card (now the last card in the DOM order)
    //           firstCard.classList.add('shuffling');
    //           firstCard.style.zIndex = cards.length;
    //           firstCard.style.transform = \`rotate(-3deg) translate(\${cards.length * 8}px, \${cards.length * 8}px)\`;

    //           // Move the first card to the end of the DOM order
    //           firstCard.parentNode.appendChild(firstCard);
    //         };

    //         // Initial setup
    //         updateDeckHeight();

    //         // Shuffle every 5 seconds
    //         setInterval(shuffleCards, 5000);

    //         // Allow manual click shuffling
    //         deck.addEventListener('click', shuffleCards);

    //         // Update height on window resize
    //         window.addEventListener('resize', updateDeckHeight);
    //       });
    //     };
    //     window.setUpPolaroids = setUpPolaroids;
    //   }
    //   document.addEventListener('DOMContentLoaded', setUpPolaroids);
    // `;
    const scriptInner = `
      if (typeof setUpPolaroids !== "function") {
        const setUpPolaroids = () => {
          const decks = document.querySelectorAll('.deck');
          decks.forEach(deck => {
            const cards = Array.from(deck.querySelectorAll('.polaroid'));
            let deckHeight = 0;
            let maxHeight = 0;

            // Step 1: Calculate max height for all cards
            cards.forEach(card => {
              const clone = card.cloneNode(true);
              clone.style.visibility = 'hidden';
              clone.style.position = 'absolute';
              clone.style.left = '-9999px';
              deck.appendChild(clone);
              clone.getBoundingClientRect(); // Force reflow
              maxHeight = Math.max(maxHeight, clone.clientHeight);
              clone.remove();
            });

            // Step 2: Apply max height and calculate offsets
            const updateDeckHeight = () => {
              deckHeight = deck.clientHeight;
              let totalOffset = 0;

              cards.forEach((card, index) => {
                card.style.minHeight = maxHeight + 'px'; // Apply the calculated max height
                const offset = index * 8;
                card.style.transform = \`rotate(-3deg) translate(\${offset}px, \${offset}px)\`;
                card.style.zIndex = index; // Set z-index based on order
                totalOffset = offset;
              });

              deck.style.height = \`\${totalOffset + deckHeight}px\`; // Set the height of the deck based on the total offset
            };

            const shuffleCards = () => {
              cards.forEach(card => card.classList.remove('shuffling'));
              const firstCard = cards.shift();
              cards.push(firstCard);

              cards.forEach((card, index) => {
                const offset = index * 8;
                card.style.zIndex = index;
                card.style.transform = \`rotate(-3deg) translate(\${offset}px, \${offset}px)\`;
              });

              firstCard.classList.add('shuffling');
              firstCard.style.zIndex = cards.length;
              firstCard.style.transform = \`rotate(-3deg) translate(\${cards.length * 8}px, \${cards.length * 8}px)\`;
              firstCard.parentNode.appendChild(firstCard);
            };

            updateDeckHeight();
            setInterval(shuffleCards, 5000);
            deck.addEventListener('click', shuffleCards);
            window.addEventListener('resize', updateDeckHeight);
          });
        };
        window.setUpPolaroids = setUpPolaroids;
      }
      document.addEventListener('DOMContentLoaded', setUpPolaroids);
    `;

    const getPhotoUrl = (image) => {
      if (image.mediaSizes.hasOwnProperty('rbt-square-md')) {
        return image.mediaSizes['rbt-square-md'].url;
      } else {
        return image.mediaUrl;
      }
    }
    return (
      <div className="rbt-ghpolaroids">
        <script dangerouslySetInnerHTML={{ __html: scriptInner }} />
        <div className="columns">
          <div className={"deck " + cardSize}>
            {cards.map(card => {
              return (
                <div className="polaroid">
                  <img src={getPhotoUrl(card.image)} alt={card.title} />
                  <div className="caption">
                    {card.title.length ? <h2><RawHTML>{card.title}</RawHTML></h2> : null}
                    {card.text.length ? <p><RawHTML>{card.text}</RawHTML></p> : null}
                  </div>
                </div>
              )
            })}
          </div>
          {(title.length || text.length) ?
            <div className="text">
              {title.length ?
                <RichText.Content
                  tagName="h2"
                  className="rbt-title"
                  value={title}
                /> : null}
              {text.length ?
                <RichText.Content
                  tagName="div"
                  className="rbt-text"
                  value={text}
                /> : null}
            </div>
            : null}
        </div>
      </div>
    )
  }
};
registerBlockType('rbt/ghpolaroids', ghpolaroids);
export default ghpolaroids;
